import { useFixedUIHidden } from '~/modules/root/hook/use-fixed-ui-hidden';
import { FeedbackIslandButton } from './FeedbackIslandButton';
import { StaffAvatarButton } from './StaffAvatarButton';
import { StaffIslandFrame, useStaffIslandHosted } from './StaffIslandFrame';

/**
 * The staff island on a page that has no tools of its own: who is holding
 * it, and the feedback control. A detail page puts up its own island with
 * the feedback control inside, and this stands down while it does.
 *
 * Mount once, at the app shell, on desktop. Gating lives at the mount site.
 */
export const StaffFeedbackIsland = () => {
    const isFixedUIHidden = useFixedUIHidden();
    const hosted = useStaffIslandHosted();
    if (hosted) return null;

    return (
        <StaffIslandFrame hidden={isFixedUIHidden}>
            <StaffAvatarButton />
            <FeedbackIslandButton />
        </StaffIslandFrame>
    );
};
